import React, { useEffect } from 'react'
import landscape from './facilitiesphotos/landscape.jpg'
import { Helmet } from "react-helmet";

const Admission = () => {


  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])



  return (
    <>
      <Helmet>
        <title>Admission Page</title>
        <meta name="description" content="Information about admission in shinde institute of pharmacy and research , Required Documents" />
      </Helmet>


      <div style={{ marginTop: "6rem" }}>
        <img src={landscape} alt="error" className="landscape" style={{ width: "100%" }}></img>
        <center>  <h1 className="centered">Home {'>'} Admission process and Eligibility  </h1>  </center>
      </div>
      <div className='container ' style={{ marginTop: "6rem" }}>
        <div className='row'>





          <h2 className="mt-3" style={{ color: "rgb(151 201 29)" }}>Shinde Institute of <span style={{ color: "rgb(44, 110, 17)" }}> Pharmacy and Research Admission Eligibility Criteria </span>  </h2><br></br>
          <hr></hr>
          <table className="table table-bordered mt-2  rounded">
            <thead>
              <tr>

                <th scope="col">First</th>
                <th scope="col">Last</th>

              </tr>
            </thead>
            <tbody>
              <tr>
                <td >{"1)"} For Maharashtra:</td>
                <td>
                  {"i) "}The Candidate should be an India National<br></br><br></br>

                  {"ii)"} For the admission to first year of Diploma course in pharmacy, the candidate should have passed higher secondary certificate H.S.C. (std.XII) Examination of Maharashtra State Board of or its equivalent examination with at least 35% marks in aggregate with Physic, Chemistry, Biology Mathematics and English</td>

              </tr>
              <tr >

                <td  > {"2)"} Other than Maharashtra State Candidates shall be eligible for institute quota only.</td>
                <td></td>


              </tr>

              <tr>

                <td > {"3)"}  NRI/OCI/PIO, Children of Indian workers in the Gulf countries, Foreign National-</td>
                <td className="">{"i)"} Passed higher secondary certificate H.S.C. (std.XII) Examination with Physics & Chemistry as compulsory subject along with one of the subject Mathematics or Biology.(Botany & Zoology)<br></br><br></br>

                  {" ii)"} Any other criteria declared from time to time by the appropriate authority as defined under the Act</td>

              </tr>
            </tbody>
          </table>



        </div>

      </div>

      <div className="container mt-5" >

        <h2 style={{ color: "rgb(151 201 29)" }}>First Year  <span style={{ color: "rgb(44, 110, 17)" }} >Required Documents for Admission :</span> </h2>
        <hr></hr>
        <table class="table table-bordered ">
          <thead>
            <tr>
              <th scope="col">Sr.No.</th>
              <th scope="col">Required</th>
              <th scope="col">Details</th>

            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">1</th>
              <td>S.S.C Marksheet</td>
              <td>Original +2 Xerox copies</td>

            </tr>
            <tr>
              <th scope="row">2</th>
              <td>H.S.C Marksheet</td>
              <td>Original +2 Xerox copies</td>

            </tr>
            <tr>
              <th scope="row">3</th>
              <td >School Leaving Certificate / TC</td>
              <td>Original +2 Xerox copies</td>
            </tr>
            <tr>
              <th scope="row">4</th>
              <td > Aadhar card Xerox copy of student  </td>
              <td>2 Xerox copies</td>
            </tr>
            <tr>
              <th scope="row">5</th>
              <td >Migration Certificate <span style={{ fontWeight: "bold" }}> (if applicable) </span></td>
              <td>Original +2 Xerox copies</td>
            </tr>
            <tr>
              <th scope="row">6</th>
              <td >Caste Certificate for <span style={{ fontWeight: "bold" }}>Category student</span></td>
              <td>Original +2 Xerox copies</td>
            </tr>
            <tr>
              <th scope="row">7</th>
              <td >Caste Validity Certificate for <span className='font-weight-bold'>Category student</span></td>
              <td>Original +2 Xerox copies</td>
            </tr>
            <tr>
              <th scope="row">8</th>
              <td >No Creawmy Layer certificate <span style={{ fontWeight: 'bold' }}> valid up to 31st March 2020 for category student  </span></td>
              <td>Original +2 Xerox copies</td>
            </tr>
            <tr>
              <th scope="row">8</th>
              <td >Nationality Certificate</td>
              <td>Original +2 Xerox copies</td>
            </tr>
            <tr>
              <th scope="row">9</th>
              <td >Income Certificate <span style={{ fontWeight: "bold" }}> (if applicable) </span></td>
              <td>Original +2 Xerox copies</td>
            </tr>
            <tr>
              <th scope="row">10</th>
              <td >Domicile Certificate</td>
              <td>Original +2 Xerox copies</td>
            </tr>
            <tr>
              <th scope="row">11</th>
              <td >Gap Certificate <span style={{ fontWeight: "bold" }}> (if applicable) </span></td>
              <td>Original +2 Xerox copies</td>
            </tr>
            <tr>
              <th scope="row">12</th>
              <td >Passport Size Photos </td>
              <td>3 copy</td>
            </tr>

          </tbody>
        </table>

        <br></br>
      </div>















    </>
  )
}

export default Admission